/**
 * In-app support categories — mirrored from Prisma `InAppSupportCategory`.
 */
export const IN_APP_SUPPORT_CATEGORY = {
  TECHNICAL: 'TECHNICAL',
  BILLING: 'BILLING',
  GENERAL: 'GENERAL',
  INQUIRIES: 'INQUIRIES',
} as const;

export type InAppSupportCategoryValue =
  (typeof IN_APP_SUPPORT_CATEGORY)[keyof typeof IN_APP_SUPPORT_CATEGORY];

export const IN_APP_SUPPORT_CATEGORY_VALUES = Object.values(
  IN_APP_SUPPORT_CATEGORY
) as InAppSupportCategoryValue[];

/**
 * Minimum support message length. Shared by the client form (button gating +
 * hint) and the server-side Zod schema so the threshold can never drift.
 */
export const MIN_SUPPORT_MESSAGE_LENGTH = 3;

/** User-facing hint shown while the message is below the minimum length. */
export const MIN_SUPPORT_MESSAGE_HINT = `Please enter at least ${MIN_SUPPORT_MESSAGE_LENGTH} characters`;
